import React, { useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import clsx from 'clsx';
import { useParams } from 'react-router';
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useLastLocation } from 'react-router-last-location';

import { TYPE, URL } from '../../../constant';
import { themaListAPI } from '../../../api/learningThemaAPI';
import { getStageCodeByGrade, getThmaNameGBCode } from '../../../utils/utilityEtc';
import { useAlert, useLearningHistory, useSound, useUserInfo } from '../../../hooks';

function ThemaList({ moveScroll, onChangeThmaCd }) {
  const webPageSize = 6;
  const uParmas = useParams();
  const lastLocaction = useLastLocation();

  const { t } = useTranslation();
  const { info } = useUserInfo();
  const { setLearningHistoryInfo } = useLearningHistory();
  const { setSound, playSound } = useSound();

  const [Alert] = useAlert();
  const [themaList, setTemaList] = useState([]);
  const [themaOriginList, setTemaOriginList] = useState([]);
  const [paging, setPageing] = useState({ total: 0, nowPage: 0, endPage: webPageSize });
  const [activitThema, setActivitThema] = useState({
    code: '',
    index: 0,
  });

  const deviceInfo = useSelector(state => state.deviceInfo);
  const isPC = _.isEqual(deviceInfo.type, TYPE.DEVICE.PC);

  useEffect(() => {
    let thema = null;
    if (uParmas && uParmas?.thema) {
      thema = uParmas.thema;
    }

    themaListAPICall(thema);
  }, []);

  useEffect(() => {
    if (isPC) return;
    // 모바일, 테블릿에서 해당 대주제 코드로 이동
    const dom = document.getElementById('lastY');
    
    setTimeout(() => {
      if (dom) {
        dom.scrollIntoView({ inline: 'center', behavior: 'smooth' });
      }
    }, 200);
  }, [activitThema]);


  const themaListAPICall = useCallback(async (parmThema) => {
    try {
      const { locale, learnerId, learnerBirth } = info;
      const data = await themaListAPI({ locale, learnerId });
      const respLength = data.resp.length;

      let themeList = data.resp;
      if (info.channelCode === TYPE.CHANNEL.GLOBAL01) {
        // let t = [...data.resp];
        themeList = themeList.splice(0, 10);
      }
      let aThema = { code: '', index: 0 };
      let pageData = isPC ? themeList.slice(0, webPageSize) : themeList;
      if (parmThema) {
        aThema = { code: parmThema, index: 0 };
      } else {
        // sessionStorage에서 마지막 선택한 주제 확인
        const savedThema = sessionStorage.getItem('lastSelectedThema');

        // 진단테스트 결과 페이지 또는 AI 진단테스트의 AI 추천학습(SelectLearningGMV2)에서 진입 했을 경우
        if (_.isEqual(lastLocaction?.pathname, URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.RESULT) ||
            _.isEqual(lastLocaction?.pathname, URL.SELECT_LEARNING)) {
          const bgnStgY = _.find(themeList, { bgnStgYn: 'Y' });
          const bgnStgY_index = _.findIndex(themeList, { bgnStgYn: 'Y' })

          // AI가 추천하는 소주제가 있을 경우
          if (bgnStgY?.thmaCd) {
            aThema = { code: bgnStgY.thmaCd, index: bgnStgY_index }
          } else {
            aThema = { code: themeList[0].thmaCd, index: 0 }
          }

        } else if (savedThema) {
          // sessionStorage에 저장된 주제가 있으면 해당 주제로 이동
          const savedThema_index = _.findIndex(themeList, { thmaCd: savedThema });
          if (savedThema_index > -1) {
            aThema = { code: savedThema, index: savedThema_index };
            console.log("***** 주제학습 - 저장된 주제로 이동:", savedThema);
          } else {
            // 저장된 주제가 목록에 없으면 기존 로직 사용
            const lastStgY = _.find(themeList, { lastStgYn: 'Y' });
            const lastStgY_index = _.findIndex(themeList, { lastStgYn: 'Y' })

            if (lastStgY?.thmaCd) {
              aThema = { code: lastStgY.thmaCd, index: lastStgY_index }
              setLearningHistoryInfo({ isLastLearningStage: 'Y' });
            } else {
              setLearningHistoryInfo({ isLastLearningStage: 'N' });
              aThema = { code: themeList[0].thmaCd, index: 0 };

              const defaultThmaCd = getStageCodeByGrade(learnerBirth);
              const defaultThma_index = _.findIndex(themeList, { thmaCd: defaultThmaCd?.thmaCd });

              if (defaultThmaCd?.age) {
                aThema = { code: defaultThmaCd.thmaCd, index: defaultThma_index };
              }
            }
          }
        } else {
          const lastStgY = _.find(themeList, { lastStgYn: 'Y' });
          const lastStgY_index = _.findIndex(themeList, { lastStgYn: 'Y' })

          // 마지막 학습한 소주제가 있을 경우
          if (lastStgY?.thmaCd) {
            aThema = { code: lastStgY.thmaCd, index: lastStgY_index }
            setLearningHistoryInfo({ isLastLearningStage: 'Y' });
          } else {
            setLearningHistoryInfo({ isLastLearningStage: 'N' });
            aThema = { code: themeList[0].thmaCd, index: 0 };

            // default로 지정한 나이, 대주제, 소주제 값
            const defaultThmaCd = getStageCodeByGrade(learnerBirth);
            const defaultThma_index = _.findIndex(themeList, { thmaCd: defaultThmaCd?.thmaCd });

            // 마지막 학습한 이력이 없을 경우 default로 지정한 소주제로 이동
            if (defaultThmaCd?.age) {
              aThema = { code: defaultThmaCd.thmaCd, index: defaultThma_index };
            }
          }

        }

        const nowPage = Math.floor(aThema.index / webPageSize);
        // web일때 default 대주제가 있는 페이지로 찾아감
        if (isPC) {
          if (nowPage > 0) {
            let nPage = (nowPage * webPageSize); // 0, 6, 12
            let ePage = (nPage + webPageSize) > respLength ? respLength : (nPage + webPageSize);
            pageData = themeList.slice(nPage, ePage)
            setPageing({
              total: respLength,
              nowPage: nPage,
              endPage: ePage
            });
          } else {
            setPageing((old) => ({
              ...old,
              total: respLength
            }))
          }
        }
      }

      setTemaList(pageData);
      setTemaOriginList(themeList);
      setActivitThema(aThema);  // 마지막 학습한 소주제 코드 데이터
      onChangeThmaCd(aThema.code);
      // 초기 로딩 시 선택된 주제도 sessionStorage에 저장
      if (aThema.code) {
        sessionStorage.setItem('lastSelectedThema', aThema.code);
      }

    } catch (error) {
      console.log("##### themaListAPICall: ", error);
    }
  }, [])

  // web버젼 대주제 페이징
  const handlePageing = useCallback((type) => {
    // 6, 12
    const { total, nowPage, endPage } = paging;
    let nPage = nowPage;
    let ePage = endPage;
    if (type === 'prev') {
      ePage = nPage;
      nPage -= webPageSize;
    } else {
      nPage += webPageSize;
      ePage = (ePage + webPageSize) > total ? total : (ePage + webPageSize);
    }

    setTemaList(themaOriginList.slice(nPage, ePage));
    setPageing({ total, nowPage: nPage, endPage: ePage });

  }, [paging, themaOriginList]);

  const handleClick = useCallback((item, index) => {
    setSound({
      src: `${process.env.PUBLIC_URL}/static/audio/common_button.ogg`,
      // src: `${process.env.PUBLIC_URL }/static/audio/mp3/lc_05_06.mp3`,
      // src: common_button
      // src: lc_05_06
    });
    playSound();
    if (item.stgCnt === 0) {
      Alert("준비중입니다.");
      return;
    };
    console.log("***** 주제학습 - 테마 변경")
    // 선택한 주제를 sessionStorage에 저장
    sessionStorage.setItem('lastSelectedThema', item.thmaCd);
    setActivitThema({ code: item.thmaCd, index })
    onChangeThmaCd(item.thmaCd);
    document.getElementById('scrollingBox').scrollTop = 0;
  }, [])

  return (
    <div
      className={clsx({
        "header sl-headerBox": true,
        "sl-header-short": moveScroll
      })}
    >
      <div className="inner">
        <span className="scrollX-gra scrollX-left"></span>
        <div
          className={clsx({
            "sl-header-wrap scrollX-wrap": true,
            "first": paging.nowPage === 0,
            "last": paging.endPage === paging.total
          })}
          style={{ textAlign: 'left' }}
          data-wmw="1104">
          <div className="scrollX-container">
            <div className="sl-header-inner ">
              <ul className="sl-header-list scrollX-cont">
                {
                  themaList.map((item, index) => (
                    <li className="js_play_audio1" key={item.thmaCd}>
                      <button
                        id={_.isEqual(item.thmaCd, activitThema.code) ? 'lastY' : ''}
                        key={index}
                        onClick={() => handleClick(item, index)}
                        className={clsx({
                          "btn-tab-active": item.thmaCd === activitThema.code,
                          "btn-tab-locked": Number(item.stgCnt) === 0
                        })}
                      >
                        <span className="ico">
                          {Number(item.stgCnt) > 0 && (
                            <img
                              src={`${item.imgFilePath}${item.imgFileNm}`} alt={item.imgFileNm}
                            />
                          )}
                        </span>
                        {t(`LC_04_01.${getThmaNameGBCode(item.thmaNm)}`)}
                      </button>
                    </li>
                  ))
                }
              </ul>
            </div>
          </div>
          <button
            className="btn-scrollX prev"
            onClick={() => handlePageing("prev")}
          >이전</button>
          <button
            className="btn-scrollX next"
            onClick={() => handlePageing("next")}
          >다음</button>
        </div>
        <span className="scrollX-gra scrollX-right"></span>
      </div>
    </div>
  );
}

export default ThemaList;